export default "__VITE_ASSET__CLXoBZqm__"